"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _configuratorSecondaryNavigation = _interopRequireDefault(require("../styles/configurator-secondary-navigation.css"));
var _configuratorSecondaryNavigation2 = require("./configurator-secondary-navigation.props/configurator-secondary-navigation.propTypes");
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var scrollWrapperToX = function scrollWrapperToX(scrollTargetX, scrollablePane, speed, easing) {
  if (scrollTargetX === void 0) {
    scrollTargetX = 0;
  }
  if (speed === void 0) {
    speed = 3000;
  }
  if (easing === void 0) {
    easing = 'easeOutSine';
  }
  var scrollX = scrollablePane.scrollLeft;
  var time = Math.max(0.1, Math.min(Math.abs(scrollX - scrollTargetX) / speed, 0.8));
  var half = 0.5;
  var exponent = 5;
  var quint = 2;
  var seconds = 60;
  var currentTime = 0;
  var easingEquations = {
    easeOutSine: function easeOutSine(pos) {
      return Math.sin(pos * (Math.PI * half));
    },
    easeInOutSine: function easeInOutSine(pos) {
      return -half * (Math.cos(Math.PI * pos) - 1);
    },
    easeInOutQuint: function easeInOutQuint(pos) {
      var nextPos = pos / half;
      if (nextPos < 1) {
        return half * Math.pow(nextPos, exponent);
      }
      return half * Math.pow(nextPos - quint, exponent) + quint;
    }
  };
  var tick = function tick() {
    currentTime += 1 / seconds;
    var p = currentTime / time;
    var t = easingEquations[easing](p);
    if (p < 1 && typeof window !== 'undefined') {
      window.requestAnimationFrame(tick);
      if (scrollablePane.scrollTo !== undefined) {
        scrollablePane.scrollTo(scrollX + (scrollTargetX - scrollX) * t, 0);
      } else {
        scrollablePane.scrollLeft = scrollX + (scrollTargetX - scrollX) * t;
      }
    } else if (scrollablePane.scrollTo !== undefined) {
      scrollablePane.scrollTo(scrollTargetX, 0);
    } else {
      scrollablePane.scrollLeft = scrollTargetX;
    }
  };
  tick();
};
var StepsWrapper = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(StepsWrapper, _React$Component);
  function StepsWrapper(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.activeMenuItem = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  var _proto = StepsWrapper.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var phase = this.props.phase;
    var prevPhase = prevProps.phase;
    var prevActiveStep = prevPhase.steps.find(function (step) {
      return step.selected === true;
    });
    var activeStep = phase.steps.find(function (step) {
      return step.selected === true;
    });

    // Only update if the active step has changed
    if (prevActiveStep.stepName !== activeStep.stepName) {
      this.updateScrollPosition();
    }
  };
  _proto.updateScrollPosition = function updateScrollPosition() {
    var scrollablePane = this.props.scrollablePane;
    var activeItemPosition = this.activeMenuItem.current.getBoundingClientRect();
    var half = 0.5;
    var positionToScrollTo = 0;

    // Can we measure the section to scroll to?
    if (activeItemPosition && typeof window !== 'undefined') {
      var itemMarginLeft = Number(window.getComputedStyle(this.activeMenuItem.current).marginLeft.replace(/[^\d&\.]/g, '')) || 0;
      positionToScrollTo = activeItemPosition.left - activeItemPosition.width * half - window.innerWidth * half + itemMarginLeft;
      // Only attempt scroll if we have a pane
      if (scrollablePane && scrollablePane.current) {
        scrollWrapperToX(positionToScrollTo + scrollablePane.current.scrollLeft, scrollablePane.current);
      }
    }
  };
  _proto.renderStepContent = function renderStepContent(step, activeStepReached) {
    var label = handleNestedProp(step, 'step.label');
    if (activeStepReached === true) {
      return label;
    }
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      "data-nav-to": step.eventId,
      className: "configuratorStepButton",
      onClick: step.changeEvent
    }, label);
  };
  _proto.render = function render() {
    var _this2 = this;
    var phase = this.props.phase;
    var activeStepReached = false;
    return /*#__PURE__*/_react["default"].createElement("ol", {
      className: _configuratorSecondaryNavigation["default"].steps,
      automation: "steps-list"
    }, phase.steps.map(function (step) {
      var _clsx;
      if (activeStepReached !== true && step.selected === true) {
        activeStepReached = step.selected;
      }
      return /*#__PURE__*/_react["default"].createElement("li", {
        automation: "step",
        key: step.label,
        className: (0, _clsx2["default"])((_clsx = {}, _clsx[_configuratorSecondaryNavigation["default"].isActive] = step.selected, _clsx[_configuratorSecondaryNavigation["default"].clickableStep] = step.changeEvent, _clsx[_configuratorSecondaryNavigation["default"].interactiveStep] = !activeStepReached, _clsx)),
        ref: step.selected ? _this2.activeMenuItem : undefined
      }, _this2.renderStepContent(step, activeStepReached));
    }));
  };
  return StepsWrapper;
}(_react["default"].Component);
exports["default"] = StepsWrapper;
StepsWrapper.displayName = 'StepsWrapper';